import React from 'react';
import {Spinner} from "react-bootstrap";

interface LoadingErrorBlockProps {
    isLoading: boolean;
    isError: boolean;
    errorMessage?: string;
}

export const LoadingErrorBlock: React.FC<LoadingErrorBlockProps> = ({
    isLoading,
    isError,
    errorMessage = 'Ошибка загрузки данных. Попробуйте обновить страницу'
}) => {
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center h-100">
                <Spinner animation="border" variant="primary"/>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="d-flex justify-content-center align-items-center h-100">
                <p className="text-danger mb-0">{errorMessage}</p>
            </div>
        );
    }

    return null;
};